
import {
    getArrayItemMax
} from './wx.js'

const typeName = ['', '满减券', '折扣券', '首单券', '买赠券', '定额券'];

class CouponModel {


    getTypeName(typeCode) {
        return typeName[typeCode];
    }


    //优惠券逻辑处理的统一方法,返回处理后的订单信息
    // eslint-disable-next-line no-unused-vars
    parseCoupon(couponInfoItem, order, hasFacility) {
        let orderNew = JSON.parse(JSON.stringify(order));
        const couponInfo = couponInfoItem;
        const couponType = couponInfo.couponType;
        const money = couponInfo.money;
        const condition = couponInfo.condition;

        // console.log("max======>" + productDeanInCondition);
        if (couponType == 2) { //折扣券
            return this._handleDiscountCoupon(orderNew, money, condition, couponInfo);
        }
        //满减券
        else if (couponType == 1) {
            return this._handleManJianCoupon(orderNew, money, condition, couponInfo);
        }
        //首单券,与定额券一个逻辑 由后台负责处理,小程序负责处理券的计价逻辑
        else if (couponType == 3) {
            return this._handleSolidPriceCoupon(orderNew, money, condition, couponInfo);
        }
        //买赠券,改为系统级活动的逻辑，小程序端不做处理了
        else if (couponType == 4) {
            return this._handleDiscountCoupon(orderNew, money, condition, couponInfo);
        }
        //定额券
        else if (couponType == 5) {
            return this._handleSolidPriceCoupon(orderNew, money, condition, couponInfo);
        } else {
            return;
        }
        // eslint-disable-next-line no-unreachable
        return orderNew;
    }

    //折扣券处理
    _handleDiscountCoupon(orderNew, money, condition, couponInfo) {
        //折扣券处理逻辑：判断商品商户，如果是一个直接打折，大于一个，找出满足条件商品，修改此商品的价格，并将总价减去此商品的又会金额，然后完成处理
        var orderDetailList = orderNew.orderDetailDOS;
        let hasCommodityCondition = this._hasProductInCondition(orderDetailList, couponInfo);
        let isCommodityCondition = this._isCommodityCondition(couponInfo);
        var orderPayAmount = 0;
        var orderSaleAmount = 0;
        if (isCommodityCondition) { //是否是有商品限制条件的券
            if (hasCommodityCondition) {
                if (orderDetailList.length == 1) { //如果有商品满足条件 且只有一种 那么说明必然是当前的满足条件
                    let payAmountPre = orderDetailList[0].payAmount;
                    orderDetailList[0].payAmount = Math.round(payAmountPre * money / 10000);
                    let saleAmount = payAmountPre - orderDetailList[0].payAmount;
                    orderSaleAmount = saleAmount;
                    orderDetailList[0].saleAmount = saleAmount;
                    orderPayAmount = orderNew.dealAmount - saleAmount;
                } else if (orderDetailList.length > 1) { //订单明细中有超过一种产品 取最大值，因为此处的价格已经被拆分成单个产品 故只对其中一个产品处理即可
                    var orderItem = this._checkProductCondition(orderNew, couponInfo);
                    let payAmountPre = orderItem.payAmount;
                    orderItem.payAmount = Math.round(orderItem.payAmount * money / 10000);
                    let saleAmount = payAmountPre - orderItem.payAmount;
                    orderItem.saleAmount = saleAmount;
                    for (let j = 0; j < orderDetailList.length; j++) {
                        let orderDetailItem = orderDetailList[j];
                        if (orderItem.commodityId == orderDetailItem.commodityId) {
                            orderDetailList[j] = orderItem;
                            // console.log("11111122222");
                            break;
                        }
                    }
                    orderSaleAmount = saleAmount;
                    orderPayAmount = orderNew.dealAmount - orderSaleAmount;
                }
            } else { //是针对商品的券但是没有符合条件的商品，此为后台处理错误，直接返回原始订单
                return orderNew;
            }

        } else { //该优惠券针对整个订单生效

            orderPayAmount = Math.round(orderNew.dealAmount * money / 10000);
            orderSaleAmount = orderNew.dealAmount - orderPayAmount;
            for (let k = 0; k < orderDetailList.length; k++) {
                orderDetailList[k].payAmount = Math.round(orderDetailList[k].payAmount * money / 10000);
            }

        }


        orderNew['orderDetailDOS'] = orderDetailList;
        orderNew['saleAmount'] = orderSaleAmount;
        orderNew['payAmount'] = orderPayAmount;
        orderNew['couponUserId'] = couponInfo.couponId;
        return orderNew;
    }

    //满减券处理，不按商品进行约束
    _handleManJianCoupon(orderNew, money, condition, couponInfo) {

        let dealAmount = orderNew.dealAmount;
        if (dealAmount >= condition) { //订单总金额大于条件金额，可以进行逻辑处理
            let payAmount = orderNew.dealAmount - money;
            let saleAmount = orderNew.dealAmount - payAmount;
            orderNew['saleAmount'] = saleAmount;
            orderNew['payAmount'] = payAmount;
            orderNew['couponUserId'] = couponInfo.couponId;
            const discountRatio = orderNew.payAmount / orderNew.dealAmount;
            let orderDetail = orderNew.orderDetailDOS;
            for (let i = 0; i < orderDetail.length; i++) {
                orderDetail[i].payAmount = Math.round(orderDetail[i].payAmount * discountRatio);
            }
            orderNew.orderDetailDOS = orderDetail;
            return orderNew;
        } else {
            return orderNew;
        }

    }

    //首单券处理
    // eslint-disable-next-line no-unused-vars
    _handleFirstBuyCoupon(orderNew, money, condition, couponInfo) {

    }

    //定额券处理,先判断是否有有商品限制条件 没有则认为是错误券，定额券必须设置产品
    _handleSolidPriceCoupon(orderNew, money, condition, couponInfo) {

        let isCommodityCondition = this._isCommodityCondition(couponInfo);
        var orderPayAmount = 0;
        var orderSaleAmount = 0;
        var orderDetailList = orderNew.orderDetailDOS;
        if (isCommodityCondition) {
            let hasCommodityCondition = this._hasProductInCondition(orderDetailList, couponInfo);
            if (hasCommodityCondition) {

                if (orderDetailList.length == 1) { //如果有商品满足条件 且只有一种 那么说明必然是当前的满足条件
                    let payAmountPre = orderDetailList[0].payAmount;
                    orderDetailList[0].payAmount = money;
                    let saleAmount = payAmountPre - orderDetailList[0].payAmount;
                    orderSaleAmount = saleAmount;
                    orderDetailList[0].saleAmount = saleAmount;
                    orderPayAmount = orderNew.dealAmount - saleAmount;
                } else if (orderDetailList.length > 1) { //订单明细中有超过一种产品 取最大值，因为此处的价格已经被拆分成单个产品 故只对其中一个产品处理即可
                    var orderItem = this._checkProductCondition(orderNew, couponInfo);
                    let payAmountPre = orderItem.payAmount;
                    orderItem.payAmount = money;
                    let saleAmount = payAmountPre - orderItem.payAmount;
                    orderItem.saleAmount = saleAmount;
                    for (let j = 0; j < orderDetailList.length; j++) {
                        let orderDetailItem = orderDetailList[j];
                        if (orderItem.commodityId == orderDetailItem.commodityId) {
                            orderDetailList[j] = orderItem;
                            break;
                        }
                    }
                    orderSaleAmount = saleAmount;
                    orderPayAmount = orderNew.dealAmount - orderSaleAmount;

                }
                orderNew['saleAmount'] = orderSaleAmount;
                orderNew['payAmount'] = orderPayAmount;
                orderNew['couponUserId'] = couponInfo.couponId;
                return orderNew;
            } else {
                return orderNew;
            }
        } else {
            if (orderNew.facilityId) {
                if (orderDetailList.length == 1) { //如果有商品满足条件 且只有一种 那么说明必然是当前的满足条件
                    let payAmountPre = orderDetailList[0].payAmount;
                    orderDetailList[0].payAmount = money;
                    let saleAmount = payAmountPre - orderDetailList[0].payAmount;
                    orderSaleAmount = saleAmount;
                    orderDetailList[0].saleAmount = saleAmount;
                    orderPayAmount = orderNew.dealAmount - saleAmount;
                    orderNew['saleAmount'] = orderSaleAmount;
                    orderNew['payAmount'] = orderPayAmount;
                    orderNew['couponUserId'] = couponInfo.couponId;
                    return orderNew;
                }
            }
            return orderNew;
        }

    }

    //是否有满足条件的产品
    _hasProductInCondition(orderDetailList, couponInfo) {
        let productIds = couponInfo.productId;
        for (let i = 0; i < orderDetailList.length; i++) {
            let productItem = orderDetailList[i];
            if (productIds.indexOf(productItem.commodityId) != -1) {
                return true;
            }
        }
        return false;
    }

    //是否有商品的限制条件
    _isCommodityCondition(couponInfo) {
        let productIds = couponInfo.productId;
        if (productIds == ',,') {
            return false;
        } else {
            return true;
        }
    }

    _parsePruductId(productIds) {
        return productIds.split(',');
    }


    //获取满足条件的商品的金额的最大值
    _checkProductCondition(orderInfo, couponInfo) {
        let orderNew = JSON.parse(JSON.stringify(orderInfo));
        let orderDetailList = orderNew.orderDetailDOS;
        let productIds = couponInfo.productId;
        if (orderDetailList.length == 1) {
            return orderDetailList[0];
        } else if (orderDetailList.length > 1) { //如果超过一个 先将全部满足条件的商品放到一个数组
            let productsInCondition = new Array; //满足条件的产品的集合
            for (let i = 0; i < orderDetailList.length; i++) {
                let productItem = orderDetailList[i];
                if (productIds.indexOf(productItem.commodityId) != -1) {
                    productsInCondition.push(productItem);
                }
            }
            if (productsInCondition != null && productsInCondition.length > 0) {
                return getArrayItemMax(productsInCondition, "dealAmount");
            }
        }

    }


}


export {
    CouponModel
}
